import { render, staticRenderFns } from "./BroadbandSelectorModal.vue?vue&type=template&id=08e23d22&scoped=true&"
import script from "./BroadbandSelectorModal.vue?vue&type=script&lang=js&"
export * from "./BroadbandSelectorModal.vue?vue&type=script&lang=js&"
import style0 from "./BroadbandSelectorModal.vue?vue&type=style&index=0&id=08e23d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e23d22",
  null
  
)

export default component.exports